import produce from "immer";
import { createAsyncAction } from "typesafe-actions";
import { ActionType, createReducer } from "typesafe-actions";
import { Comment, ServiceRequestUpdate } from "../../../Types/UnitFeatureTypes";


interface ServiceRequestUpdateRequestState {
  request: {
    loading: boolean;
    success: boolean;
    error: string | null;
    serviceRequestUpdateData: ServiceRequestUpdate;
  };
}

export enum Types {
  ADD_SERVICE_REQUEST_UPDATE_REQUEST = 'ADD_SERVICE_REQUEST_UPDATE_REQUEST',
  ADD_SERVICE_REQUEST_UPDATE_SUCCESS = 'ADD_SERVICE_REQUEST_UPDATE_SUCCESS',
  ADD_SERVICE_REQUEST_UPDATE_FAILURE = 'ADD_SERVICE_REQUEST_UPDATE_FAILURE',
  DELETE_SERVICE_REQUEST_UPDATE_REQUEST = 'DELETE_SERVICE_REQUEST_UPDATE_REQUEST',
  DELETE_SERVICE_REQUEST_UPDATE_SUCCESS = 'DELETE_SERVICE_REQUEST_UPDATE_SUCCESS',
  DELETE_SERVICE_REQUEST_UPDATE_FAILURE = 'DELETE_SERVICE_REQUEST_UPDATE_FAILURE',
}

const addServiceRequestUpdateAction = createAsyncAction(
  Types.ADD_SERVICE_REQUEST_UPDATE_REQUEST,
  Types.ADD_SERVICE_REQUEST_UPDATE_SUCCESS,
  Types.ADD_SERVICE_REQUEST_UPDATE_FAILURE,
)
<
  { serviceRequestUpdateData: Comment },
  void,
  { message: string }
>();

const deleteServiceRequestUpdateAction = createAsyncAction(
  Types.DELETE_SERVICE_REQUEST_UPDATE_REQUEST,
  Types.DELETE_SERVICE_REQUEST_UPDATE_SUCCESS,
  Types.DELETE_SERVICE_REQUEST_UPDATE_FAILURE,
)
<
  { id: string, user_id: string },
  void,
  { message: string }
>();

export const Actions = { addServiceRequestUpdateAction, deleteServiceRequestUpdateAction };

export const initialState: ServiceRequestUpdateRequestState = {
  request: {
    loading: false,
    error: null as string | null,
    success: true,
    serviceRequestUpdateData: {} as ServiceRequestUpdate
  }
};

export type ServiceRequestUpdatesState = typeof initialState;

const addServiceRequestUpdateRequest = (state = initialState) =>
  produce(state, (draft) => {
    draft.request.loading = true;
    draft.request.success = false;
    draft.request.error = null;

    return draft;
  });

const addServiceRequestUpdateSuccess = (
  state = initialState,
) =>
  produce(state, (draft) => {
    draft.request.error = null;
    draft.request.success = true;
    if (draft.request.success) {
      draft.request.loading = false;
    }

    return draft;
  });

const addServiceRequestUpdateFailure = (
  state = initialState,
  { payload }: ActionType<typeof Actions.addServiceRequestUpdateAction.failure>
) =>
  produce(state, (draft) => {
    draft.request.loading = false;
    draft.request.error = payload.message;

    return draft;
  });

const deleteServiceRequestUpdateRequest = (state = initialState) =>
  produce(state, (draft) => {
    draft.request.loading = true;
    draft.request.success = false;
    draft.request.error = null;

    return draft;
  });

const deleteServiceRequestUpdateSuccess = (
  state = initialState,
) =>
  produce(state, (draft) => {
    draft.request.error = null;
    draft.request.success = true;
    if (draft.request.success) {
      draft.request.loading = false;
    }

    return draft;
  });

const deleteServiceRequestUpdateFailure = (
  state = initialState,
  { payload }: ActionType<typeof Actions.deleteServiceRequestUpdateAction.failure>
) =>
  produce(state, (draft) => {
    draft.request.loading = false;
    draft.request.error = payload.message;

    return draft;
  });


export default createReducer<typeof initialState, ActionType<typeof Actions>>(
  initialState
)
  .handleAction(Actions.addServiceRequestUpdateAction.request, addServiceRequestUpdateRequest)
  .handleAction(Actions.addServiceRequestUpdateAction.success, addServiceRequestUpdateSuccess)
  .handleAction(Actions.addServiceRequestUpdateAction.failure, addServiceRequestUpdateFailure)
  .handleAction(Actions.deleteServiceRequestUpdateAction.request, deleteServiceRequestUpdateRequest)
  .handleAction(Actions.deleteServiceRequestUpdateAction.success, deleteServiceRequestUpdateSuccess)
  .handleAction(Actions.deleteServiceRequestUpdateAction.failure, deleteServiceRequestUpdateFailure);
  